const DocumentsIcon = () => {
    return (
        <svg
            fill="var(--icons)"
            height="30px"
            width="30px"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M20 2H10C8.346 2 7 3.346 7 5v22c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V9l-7-7zm5 25c0 .551-.449 1-1 1H10c-.551 0-1-.449-1-1V5c0-.551.449-1 1-1h9v5c0 .553.447 1 1 1h5v17zm-4-21h-3V3l5 5h-2z" />
            <path d="M12 15h10v2H12zM12 19h10v2H12zM12 23h7v2h-7z" />
        </svg>
    );
};

export default DocumentsIcon;
